import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// CONTEXT
import { AuthProvider } from 'context/AuthContext';
import { ToastProvider } from 'context/ToastContext';
import { ThemeProvider } from 'context/ThemeContext';
import { SeasonThemeProvider } from 'context/SeasonThemeContext';
import { MenuProvider } from 'context/MenuContext';
import { ConnectionProvider } from 'context/ConnectionContext';

// PAGES
import Home from 'pages/home';
import EditInterface from 'pages/editInterface';
import Admin from 'pages/admin';
import Error from 'pages/error';
import Maintenance from 'pages/maintenance';
import NotFound from 'pages/notFound';

// COMPONENTS
import ProtectedRoute from 'components/protectedRoute';
import Loader from 'components/loaderComponent';
import HubStatusCheck from 'components/HubStatusCheck';
import SeasonalEffects from 'components/effects';

// UTILS
import checkForUpdates from 'utils/checkForUpdates';
import { checkBackendHealth } from 'services/healthCheck';

// STYLES
import 'assets/css/SeasonalEffects.css';

function App() {
    const [isBackendHealthy, setIsBackendHealthy] = useState(true);
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        const checkHealth = async () => {
            const isHealthy = await checkBackendHealth();
            setIsBackendHealthy(isHealthy);
            setIsChecking(false);
        };
        checkHealth();
    }, []);

    checkForUpdates();
    
    return (
        <SeasonThemeProvider>
            {isChecking ? (
                <Loader />
            ) : !isBackendHealthy ? (
                <Maintenance />
            ) : (
                <AuthProvider>
                    <HubStatusCheck>
                        <ToastProvider>
                            <ThemeProvider>
                                <MenuProvider>
                                    <ConnectionProvider>
                                        <Router>
                                            <Routes>
                                                <Route path="/" element={<Home />} />
                                                <Route path="/edit-interface" element={
                                                    <ProtectedRoute>
                                                        <EditInterface />
                                                    </ProtectedRoute>
                                                } />
                                                <Route path="/admin/*" element={
                                                    <ProtectedRoute adminOnly={true}>
                                                        <Admin />
                                                    </ProtectedRoute>
                                                } />
                                                <Route path="/error" element={<Error />} />
                                                <Route path="*" element={<NotFound />} />
                                            </Routes>
                                        </Router>
                                        <SeasonalEffects />
                                    </ConnectionProvider>
                                </MenuProvider>
                            </ThemeProvider>
                        </ToastProvider>
                    </HubStatusCheck>
                </AuthProvider>
            )}
        </SeasonThemeProvider>
    );
}

export default App;